import getFromCdn from '@anm/helpers/getFromCdn';
import { FC } from 'react';

import MetaHead from '../../../MetaHead';

export type SignUpMetaHeadProps = { path?: string };

const SignUpMetaHead: FC<SignUpMetaHeadProps> = ({ path }) => (
  <MetaHead
    path={path}
    title="Sign Up"
    description="Sign up free to Wave.video, a versatile video marketing platform for creating, editing, and hosting video content. Start exploring the world of video today!"
    preview={getFromCdn('images/data/meta_preview.jpg')}
    size={{ width: 400, height: 300 }}
  />
);

export default SignUpMetaHead;
